import { api } from "../../services";

// eslint-disable-next-line import/prefer-default-export
export const getSubscriptionHistory = async (userId: any, subscriptionId: any) => {
  const { status, body } = await api.get({
    path: `hiatus/subscriptions/user/${userId}/subscription/${subscriptionId}/history`,
  });
  return { status, body };
};
